import React, {useEffect, useState} from 'react';
import {Element} from 'react-scroll';
import {GetStaticProps} from 'next';
import {connect} from 'react-redux';
import {useRequest} from 'ahooks';
import {Skeleton} from "antd";
import {PageWrapper} from '@/components';
import Banner from '@/page-components/detail/Banner';
import Intro from '@/page-components/detail/Intro';
import Job from '@/page-components/detail/Job';
import {TExamDetailFixedDataType, TExamKind} from '@/types';
import {TUserInfoTypes} from '@/types/redux_type';
import {VerifyEnum} from '@/types/verify';
import {apiExamInfo} from '@/services/exam_detail';
import {TExamPlanItem} from '@/page-components/detail/Intro/exam_plan';
import * as FCRAJSON from '@/constants/fcra.json';
import * as FCASHUZHINIAO_JSON from '@/constants/fca_shuzhiniao.json';
import * as FCRPDJSON from '@/constants/fcrpd.json';
import * as FCRPJSON from '@/constants/fcrp.json';
import * as FCBAJSON from '@/constants/fcba.json';
import * as FCBA5JSON from '@/constants/fcba5.json';
import * as FCBPJSON from '@/constants/fcbp.json';
import * as FCBP6JSON from '@/constants/fcbp6.json';
import * as FCAAJSON from '@/constants/fcaa.json';
import * as FCAPJSON from '@/constants/fcap.json';
import * as FCJPJSON from '@/constants/fcjp.json';
import * as FCJAJSON from '@/constants/fcja.json';
import * as FCADATAJSON from '@/constants/fca_data_analysis.json';
import * as FCPDATAJSON from '@/constants/fcp_data_analysis.json';
import * as FCPDBUSINESS_DATAJSON from '@/constants/fcp_business_data_analysis.json';
import * as FCPPLUGINJSON from '@/constants/fcp_plugin.json';
import * as FCAJIUSHUYUN from '@/constants/fca_jiushuyun.json';
import * as FINEDATALINKJSON from '@/constants/finedatalink.json';
import * as FCA_CHATBI_JSON from '@/constants/fca_chatbi.json';
import * as FCA_AI_JSON from '@/constants/fca_ai.json';
import {DetailContext} from '@/context/detailContext';
import styles from '../../styles/pages/ExamDetail.module.less';

type TExamDetail = {
  type: TExamKind;
  pageStaticData: TExamDetailFixedDataType;
  userInfo: TUserInfoTypes;
};

const ExamDetail: React.FC<TExamDetail> = ({
                                             userInfo,
                                             type,
                                             pageStaticData,
                                           }) => {
  const [loading, setLoading] = useState(false);
  const [signupInfo, setSignupInfo] = useState<TExamPlanItem[]>([]);
  const [isHistoryPass, setIsHistoryPass] = useState(false); // 是否有历史通过记录

  // 获取用户报名信息基本情况
  const {run: getExamInfo} = useRequest(
    () => {
      return apiExamInfo(pageStaticData.cert_id);
    },
    {
      manual: true,
      loadingDelay: 1000,
      debounceWait: 1000,
      onError: () => {
        setLoading(false);
      },
      onSuccess: (res) => {
        if (res.code === 200 && res.data) {
          setLoading(false);
          if (Array.isArray(res.data)) {
            setSignupInfo(res.data);
          } else if (res.data.isHistoryPass) {
            setIsHistoryPass(res.data.isHistoryPass);
          }
        } else {
          setLoading(false);
        }
        console.log('用户报名信息');
        console.log(res);
      },
    },
  );
  useEffect(() => {
    if (userInfo.uid && pageStaticData.cert_id) {
      setLoading(true);
      getExamInfo();
    } else {
      setLoading(false);
    }
  }, [userInfo, pageStaticData.cert_id]);

  return (
    <DetailContext.Provider
      value={{
        isAddExtraHeight: signupInfo.length === 0,
        isHistoryPass,
        userInfo,
        cert_id: pageStaticData.cert_id,
        signupInfo,
        data: pageStaticData,
      }}
    >
      <PageWrapper className={styles.detail_wrapper}>
        {pageStaticData && (
          <>
            <Banner/>
            <Element name="anchor1" className="element" key="anchor1">
              {loading ? <Skeleton/> : <Intro/>}
            </Element>

            <Job data={pageStaticData}/>
          </>
        )}
      </PageWrapper>
    </DetailContext.Provider>
  );
};
export default connect((state: { userInfo: TUserInfoTypes }) => {
  return state;
})(ExamDetail);

export async function getStaticPaths() {
  return {
    paths: [
      `/detail/${process.env.NEXT_PUBLIC_FCRA_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCRPD_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCRP_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCBA_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCBA5_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCBP_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCBP6_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCAA_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCAP_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCJA_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCJP_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCA_SHUZHINIAO_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCP_PLUGIN_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCA_DATA_ANALYSIS_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCP_DATA_ANALYSIS_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_JIUSHUYUN_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FINEDATALINK_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCP_BUSINESS_DATA_ANALYSIS_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCA_FINE_CHATBI_CERTID}`,
      `/detail/${process.env.NEXT_PUBLIC_FCA_AI_CERTID}`,
    ],
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps = async (context) => {
  const {type: certId} = context?.params as { type: string };
  // Partial：EJC 等新级别走独立路由（/detail/ejc/[id]），不在此页面枚举全量数据
  const allPageStaticData: Partial<{ [key in TExamKind]: TExamDetailFixedDataType }> = {
    fca_ai: {
      cert_id: process.env.NEXT_PUBLIC_FCA_AI_CERTID as string,
      isProfession: false,
      type: 'fca_ai',
      typeEnum: VerifyEnum.FCA_AI,
      ...FCA_AI_JSON,
      exam_info: {
        pass_tips: '<div><div>恭喜你通过 FCA-AI应用认知认证！</div><div class="tiny-text"><a href="https://home.fanruan.com/topic/ai" target="_blank">欢迎前往帆软AI专题区</a>，解锁最新AI线下活动、AI打卡营、AI精品课等学习资源，不断提升AI应用能力。</div>',
        pass_link: ``,
        no_pass_tips: '<div><div>很遗憾，你暂未通过 FCA-AI应用认知认证。</div><div class="tiny-text">建议补充AI基础认知、应用理解、人机协同及风险合规等方面知识后再次参加。</div>',
        signup_text: [
          '<p>报名必须通过实名认证<a href="https://fanruanclub.com/#/info/auth/realname/" target="_blank">(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fca_ai_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '40分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    finedatalink: {
      cert_id: process.env.NEXT_PUBLIC_FINEDATALINK_CERTID as string,
      isProfession: false,
      type: 'finedatalink',
      typeEnum: VerifyEnum.FINEDATALINK,
      ...FINEDATALINKJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-FineDataLink认证',
        pass_link: ``,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href="https://fanruanclub.com/#/info/auth/realname/" target="_blank">(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/finedatalink_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '40分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcra: {
      cert_id: process.env.NEXT_PUBLIC_FCRA_CERTID as string,
      isProfession: false,
      type: 'fcra',
      typeEnum: VerifyEnum.FCRA,
      ...FCRAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-FineReport认证',
        pass_link: `<a href=/detail/${process.env.NEXT_PUBLIC_FCRP_CERTID}>进一步挑战资深证书，了解FCP-报表开发工程师考试</a>`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href="https://fanruanclub.com/#/info/auth/realname/" target="_blank">(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcra_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '35分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fca_shuzhiniao: {
      cert_id: process.env.NEXT_PUBLIC_FCA_SHUZHINIAO_CERTID as string,
      isProfession: false,
      type: 'fca_shuzhiniao',
      typeEnum: VerifyEnum.FCA_SHUZHINIAO,
      ...FCASHUZHINIAO_JSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-数知鸟认证',
        pass_link: '<a target="_blank" href="https://shuzhiniao.com/web/#/login">实践使用解锁更多提效可能</a>',
        no_pass_tips: '很遗憾，未通过FCA-数知鸟认证，<a target=\'_blank\' href=\'https://help.fanruan.com/shuzhiniao/doc-view-58.html\'>可以联系官方人员解答功能使用问题，更快通过考试</a>',
        signup_text: [
          '<p>报名必须通过实名认证<a href="https://fanruanclub.com/#/info/auth/realname/" target="_blank">(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fca_shuzhiniao_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '25分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcrpd: {
      cert_id: process.env.NEXT_PUBLIC_FCRPD_CERTID as string,
      isProfession: true,
      type: 'fcrpd',
      typeEnum: VerifyEnum.FCRPD,
      ...FCRPDJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-报表交付工程师认证',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益 ，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-报表交付工程师认证',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-FineReport认证<a href=/detail/${process.env.NEXT_PUBLIC_FCRA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.自由选择考试时间，从考试开始时间起，96小时内需提交答卷。',
          '4.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '5.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '6.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        fcrpd_text: [
          '<p>1.可以代他人报名，仅可以代本组织中的成员进行报名，点击前往 <a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>组织成员管理</a></p>',
          '2.代他人报名成功后，建议您及时通知报名人员，告知其考试信息和考试时间；',
          '3.自由选择考试时间，从考试开始时间起，96小时内需提交答卷。',
          '4.报名前请仔细确认考试人员和时间信息，一旦报考成功不允许取消和改期；',
          '5.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '6.考试期间内考生请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcrpd_leida.png',
        require: '通过FCA-FineReport考试',
        duration: '4天（自选考试时间，从考试开始时间起需96小时内完成）',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '总分不低于240分，且除kettle数据外其他三个模块的分数不低于60分',
        subjects: [
          {
            label: 'FineReport报表开发模块',
            price: '99',
          },
          {
            label: 'SQL编程语言模块',
            price: '100',
          },
          {
            label: '服务器部署模块',
            price: '100',
          },
          {
            label: 'kettle数据处理模块',
            price: '100',
          },
        ],
      },
    },
    fcrp: {
      cert_id: process.env.NEXT_PUBLIC_FCRP_CERTID as string,
      isProfession: true,
      type: 'fcrp',
      typeEnum: VerifyEnum.FCRP,
      ...FCRPJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-报表开发工程师认证',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益 ，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-报表开发工程师认证',
        no_pass_link: '<a href=\'https://bbs.fanruan.com/course/report/standard?fcrp_fail\'>科学深度打磨体系化课程 8周轻松拿下认证</a>',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-FineReport认证<a href=/detail/${process.env.NEXT_PUBLIC_FCRA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcrp_leida.png',
        require: '通过FCA-FineReport',
        duration: '2天起',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上即为通过',
        subjects: [
          {
            label: 'FineReport实操考试',
            price: '399',
          },
        ],
      },
    },
    fcba: {
      cert_id: process.env.NEXT_PUBLIC_FCBA_CERTID as string,
      isProfession: false,
      type: 'fcba',
      typeEnum: VerifyEnum.FCBA,
      ...FCBAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-FineBI认证',
        pass_link: `<a href=/detail/${process.env.NEXT_PUBLIC_FCBP6_CERTID}>进一步挑战资深证书，了解FCP-FineBI考试</a>`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcba_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '45分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcba5: {
      cert_id: process.env.NEXT_PUBLIC_FCBA5_CERTID as string,
      isProfession: false,
      type: 'fcba5',
      typeEnum: VerifyEnum.FCBA5,
      ...FCBA5JSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-FineBI认证',
        pass_link: `<a href=/detail/${process.env.NEXT_PUBLIC_FCBP_CERTID}>进一步挑战资深证书，了解FCP-FineBI考试</a>`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcba5_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '30分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcbp: {
      cert_id: process.env.NEXT_PUBLIC_FCBP_CERTID as string,
      isProfession: true,
      type: 'fcbp',
      typeEnum: VerifyEnum.FCBP,
      ...FCBPJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-FineBI V5.x认证',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益 ，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-FineBI V5.x认证',
        no_pass_link: '<a href=\'https://bbs.fanruan.com/course/BI/standard?fcbp_fail\'>BI线上学习班5～9周系统教学，助教全程辅导，更有丰厚奖学金带你高效备战！</a>',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-FineBI认证<a href=/detail/${process.env.NEXT_PUBLIC_FCBA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcbp_leida.png',
        require: '通过FCA-FineBI考试',
        duration: '2天起',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上即为通过',
        subjects: [
          {
            label: 'FineBI实操考试',
            price: '399',
          },
        ],
      },
    },
    fcbp6: {
      cert_id: process.env.NEXT_PUBLIC_FCBP6_CERTID as string,
      isProfession: true,
      type: 'fcbp',
      typeEnum: VerifyEnum.FCBP6,
      ...FCBP6JSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-FineBI V6.0认证',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益 ，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-FineBI V6.0认证',
        no_pass_link: '<a href=\'https://bbs.fanruan.com/course/BI/standard?fcbp_fail\'>BI线上学习班5～9周系统教学，助教全程辅导，更有丰厚奖学金带你高效备战！</a>',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-FineBI认证<a href=/detail/${process.env.NEXT_PUBLIC_FCBA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcbp6_leida.png',
        require: '通过FCA-FineBI考试',
        duration: '2天起',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上即为通过',
        subjects: [
          {
            label: 'FineBI实操考试',
            price: '399',
          },
        ],
      },
    },
    fcaa: {
      cert_id: process.env.NEXT_PUBLIC_FCAA_CERTID as string,
      isProfession: false,
      type: 'fcaa',
      typeEnum: VerifyEnum.FCAA,
      ...FCAAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-业务分析理论认证',
        pass_link: `<a href=/detail/${process.env.NEXT_PUBLIC_FCAP_CERTID}>进一步挑战资深证书，了解FCP-业务分析师</a>`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcaa_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '30分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcap: {
      cert_id: process.env.NEXT_PUBLIC_FCAP_CERTID as string,
      isProfession: true,
      type: 'fcap',
      typeEnum: VerifyEnum.FCAP,
      ...FCAPJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-业务分析师',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-业务分析师认证',
        no_pass_link: '<a href=\'https://bbs.fanruan.com/course/DOO/enterprise\'>数据运营官课程，助你轻松拿下认证，全面提升数据运营能力！</a>',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-业务分析理论认证<a href=/detail/${process.env.NEXT_PUBLIC_FCAA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcap_leida.png',
        require: '通过FCA-业务分析理论考试',
        duration: '2天起',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上即为通过',
        subjects: [
          {
            label: 'FCP-业务分析师',
            price: '399',
          },
        ],
      },
    },
    fcjp: {
      cert_id: process.env.NEXT_PUBLIC_FCJP_CERTID as string,
      isProfession: true,
      type: 'fcjp',
      typeEnum: VerifyEnum.FCJP,
      ...FCJPJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-零代码开发工程师认证',
        pass_link: '<a href=\'https://bbs.fanruan.com/thread-135004-1-1.html\'>现可领取数据人才服务权益，助你实现职业晋升</a>',
        no_pass_tips: '很遗憾，未通过FCP-零代码开发工程师认证',
        no_pass_link: '<a href=\'https://bbs.fanruan.com/course/jiandaoyun/standard\'>精心打磨5-8周课程，理论学习+上手实操+助教辅导，助你成为简大师！ </a>',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-简道云认证<a href=/detail/${process.env.NEXT_PUBLIC_FCJA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
        ],
        leida_url: '/img/detail/leida/fcja_leida.png',
        require: '通过FCA-简道云考试',
        duration: '2天起',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '70分及以上即为通过',
        subjects: [
          {
            label: 'Jian Dao Yun实操考试',
            price: '399',
          },
        ],
      },
    },
    fcja: {
      cert_id: process.env.NEXT_PUBLIC_FCJA_CERTID as string,
      isProfession: false,
      type: 'fcja',
      typeEnum: VerifyEnum.FCJA,
      ...FCJAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-简道云认证',
        pass_link: `<a href=/detail/${process.env.NEXT_PUBLIC_FCJP_CERTID}>进一步挑战资深证书，了解FCP-零代码开发工程师认证</a>`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcja_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '35分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fca_data_analysis: {
      cert_id: process.env.NEXT_PUBLIC_FCA_DATA_ANALYSIS_CERTID as string,
      isProfession: false,
      type: 'fca_data_analysis',
      typeEnum: VerifyEnum.FCA_DATA_ANALYSIS,
      ...FCADATAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-数据分析理论',
        pass_link: `今年9月前将推出FCP-数据分析师（业务方向）敬请期待`,
        no_pass_tips: '加油，你离通过就差一次完整复习',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fca_data_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '30分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcp_business_data_analysis: {
      cert_id: process.env
        .NEXT_PUBLIC_FCP_BUSINESS_DATA_ANALYSIS_CERTID as string,
      isProfession: true,
      type: 'fcp_business_data_analysis',
      typeEnum: VerifyEnum.FCP_BUSINESS_DATA_ANALYSIS,
      ...FCPDBUSINESS_DATAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-商业数据分析师',
        pass_link: `<a href="https://bbs.fanruan.com/thread-135004-1-1.html" target="_blank">现可领取数据人才服务权益 ，助你实现职业晋升</a>`,
        no_pass_tips: '很遗憾，未通过FCP-商业数据分析师',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcp_business_data_leida.png',
        require: '需要通过前置认证 FCA-数据分析理论',
        duration: '48小时答题时间',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcp_data_analysis: {
      cert_id: process.env.NEXT_PUBLIC_FCP_DATA_ANALYSIS_CERTID as string,
      isProfession: true,
      type: 'fcp_data_analysis',
      typeEnum: VerifyEnum.FCP_DATA_ANALYSIS,
      ...FCPDATAJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-数据分析师',
        pass_link: `<a href="https://bbs.fanruan.com/thread-135004-1-1.html" target="_blank">现可领取数据人才服务权益 ，助你实现职业晋升</a>`,
        no_pass_tips: '很遗憾，未通过FCP-数据分析师',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fcp_data_leida.png',
        require: '通过FCA-数据分析理论考试',
        duration: '48小时答题时间',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fcp_plugin: {
      cert_id: process.env.NEXT_PUBLIC_FCP_PLUGIN_CERTID as string,
      isProfession: true,
      type: 'fcp_plugin',
      typeEnum: VerifyEnum.FCP_PLUGIN,
      ...FCPPLUGINJSON,
      exam_info: {
        pass_tips: '恭喜通过FCP-FineReport插件开发工程师认证',
        pass_link: `<a href="http://dev.fanruan.com/" target="_blank">加入开发者联盟，解锁更多插件开发技能</a>`,
        no_pass_tips: '很遗憾，未通过FCP-FineReport插件开发工程师认证',
        signup_text: [
          `<p>1.报名必须通过实名认证<a href='https://fanruanclub.com/#/info/auth/realname/' target='_blank'>(立即认证)</a>，并获得FCA-简道云认证<a href=/detail/${process.env.NEXT_PUBLIC_FCJA_CERTID} target='_blank'>(戳我了解)</a></p>`,
          '2.报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
          '3.确认报名后需要支付报名费用，支付成功后即为报名成功；',
          '4.付费报名的考试不通过时将会赠送一张补考优惠券（自发放起半年内有效），可用于补考免费报名；',
          '5.考试期间内请回到本页面查看试卷作答并上传答卷，过期未上传视为考试不通过。',
          '6.【FCP-FineReport插件开发工程师考生注意】进入考试后，需要先完成问卷填写，选择对应方向与模块后，软将根据考生选择的方向定制专属题目，两个工作日内发往预留邮箱中，请注意查收。后续试卷提交要在网页中完成上传。',
        ],
        leida_url: '/img/detail/leida/fcp_plugin_leida.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '3周（自己选择开考时间）',
        method: '线上考试',
        exam_money: 399,
        pass_condition: '完成插件的开发且功能合格',
        extra_tips: [
          {
            label: '定制题目',
            value: '进入考试页面后需要填写问卷并提交，帆软将根据考生选择的方向定制专属题目，两个工作日内发往预留邮箱中。',
          },
        ],
      },
    },
    fca_jiushuyun: {
      cert_id: process.env.NEXT_PUBLIC_JIUSHUYUN_CERTID as string,
      isProfession: false,
      type: 'fca_jiushuyun',
      typeEnum: VerifyEnum.FCA_JIUSHUYUN,
      ...FCAJIUSHUYUN,
      exam_info: {
        pass_tips: '恭喜通过FCA-九数云认证',
        pass_link: `<a href="https://work.jiushuyun.com/decision/home" target="_blank">实践使用，解锁更多提效可能</a>`,
        no_pass_tips: '<a href=\'https://help.fanruan.com/jiushuyun/doc-view-111.html\' target=\'_blank\'>可以联系官方人员，解答功能使用问题，更快通过考试</a>',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fca_jiushuyun.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '30分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
    fca_chatbi: {
      cert_id: process.env.NEXT_PUBLIC_FCA_FINE_CHATBI_CERTID as string,
      isProfession: false,
      type: 'fca_chatbi',
      typeEnum: VerifyEnum.FCA_CHATBI,
      ...FCA_CHATBI_JSON,
      exam_info: {
        pass_tips: '恭喜通过FCA-FineChatBI认证',
        pass_link: `<a href="https://pcdemo.finebi.com/webroot/decision#/chatbiintro" target="_blank">实践使用，解锁更多提效可能</a>`,
        no_pass_tips: '<a href=\'https://help.fanruan.com/finebi/doc-view-2572.html\' target=\'_blank\'>参考产品文档，助您快速通过考试！</a>',
        signup_text: [
          '<p>报名必须通过实名认证<a href=\'https://fanruanclub.com/#/info/auth/realname/\' target=\'_blank\'>(立即认证)</a></p>',
          '报名前请仔细确认考试时间信息，一旦报考成功不允许取消和改期；',
        ],
        leida_url: '/img/detail/leida/fca_chatbi.png',
        require: '通过<a href=\'https://fanruanclub.com/#/info/auth/realname\' target=\'_blank\'>实名认证</a>',
        duration: '45分钟',
        method: '线上考试',
        exam_money: 0,
        pass_condition: '60分及以上（满分100分）',
      },
    },
  };
  let pageStaticData;
  const typeMapping: { type: TExamKind; certId: string }[] = [
    {
      type: 'fcra',
      certId: process.env.NEXT_PUBLIC_FCRA_CERTID as string,
    },
    {
      type: 'fca_shuzhiniao',
      certId: process.env.NEXT_PUBLIC_FCA_SHUZHINIAO_CERTID as string,
    },
    {
      type: 'fcrp',
      certId: process.env.NEXT_PUBLIC_FCRP_CERTID as string,
    },
    {
      type: 'fcrpd',
      certId: process.env.NEXT_PUBLIC_FCRPD_CERTID as string,
    },
    {
      type: 'fcba',
      certId: process.env.NEXT_PUBLIC_FCBA_CERTID as string,
    },
    {
      type: 'fcba5',
      certId: process.env.NEXT_PUBLIC_FCBA5_CERTID as string,
    },
    {
      type: 'fcbp',
      certId: process.env.NEXT_PUBLIC_FCBP_CERTID as string,
    },
    {
      type: 'fcbp6',
      certId: process.env.NEXT_PUBLIC_FCBP6_CERTID as string,
    },
    {
      type: 'fcaa',
      certId: process.env.NEXT_PUBLIC_FCAA_CERTID as string,
    },
    {
      type: 'fcap',
      certId: process.env.NEXT_PUBLIC_FCAP_CERTID as string,
    },
    {
      type: 'fcja',
      certId: process.env.NEXT_PUBLIC_FCJA_CERTID as string,
    },
    {
      type: 'fcjp',
      certId: process.env.NEXT_PUBLIC_FCJP_CERTID as string,
    },
    {
      type: 'fca_data_analysis',
      certId: process.env.NEXT_PUBLIC_FCA_DATA_ANALYSIS_CERTID as string,
    },
    {
      type: 'fcp_plugin',
      certId: process.env.NEXT_PUBLIC_FCP_PLUGIN_CERTID as string,
    },
    {
      type: 'fca_jiushuyun',
      certId: process.env.NEXT_PUBLIC_JIUSHUYUN_CERTID as string,
    },
    {
      type: 'fcp_data_analysis',
      certId: process.env.NEXT_PUBLIC_FCP_DATA_ANALYSIS_CERTID as string,
    },
    {
      type: 'finedatalink',
      certId: process.env.NEXT_PUBLIC_FINEDATALINK_CERTID as string,
    },
    {
      type: 'fcp_business_data_analysis',
      certId: process.env
        .NEXT_PUBLIC_FCP_BUSINESS_DATA_ANALYSIS_CERTID as string,
    },
    {
      type: 'fca_chatbi',
      certId: process.env
        .NEXT_PUBLIC_FCA_FINE_CHATBI_CERTID as string,
    },
    {
      type: 'fca_ai',
      certId: process.env
        .NEXT_PUBLIC_FCA_AI_CERTID as string,
    },
  ];

  function calcType(): TExamKind {
    if (certId) {
      const findItem = typeMapping.find((typeObj) => typeObj.certId === certId);
      if (findItem) {
        return findItem.type;
      }
      return 'fcra';
    }
    return 'fcra';
  }

  const type = calcType();
  console.log('type是', type);
  if (
    type &&
    [
      'fcra',
      'fcrp',
      'fcrpd',
      'fcba',
      'fcba5',
      'fcbp',
      'fcbp6',
      'fcaa',
      'fcap',
      'fcja',
      'fcjp',
      'fca_shuzhiniao',
      'fca_data_analysis',
      'fcp_plugin',
      'fca_jiushuyun',
      'fcp_data_analysis',
      'finedatalink',
      'fcp_business_data_analysis',
      'fca_chatbi',
      'fca_ai'
    ].includes(type)
  ) {
    pageStaticData = allPageStaticData[type];
  }
  return {
    props: {
      type,
      pageStaticData,
      layout: 'master',
      title: pageStaticData?.title,
      description: pageStaticData?.intro,
      footerInfo: {
        havePcFooter: true,
        haveMobileFooter: false,
      },
      name: '',
    },
  };
};
